import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimesCircle,  faCheckCircle } from '@fortawesome/free-regular-svg-icons'

export default {
  install() {
    library.add(faTimesCircle)
    library.add(faCheckCircle)
  }
}
